import type { AppRole, NavItem } from '../types';

export const roleHome: Record<AppRole, string> = {
  super_admin: '/admin/dashboard',
  content_admin: '/admin/dashboard',
  reviewer: '/reviewer/dashboard',
  teacher: '/teacher/dashboard',
  parent: '/parent/dashboard',
  student: '/student/dashboard',
};

export const roleNavigation: Record<AppRole, NavItem[]> = {
  super_admin: [
    { label: 'Dashboard', path: '/admin/dashboard', icon: '⌂' },
    { label: 'Question Bank', path: '/admin/questions', icon: 'Q' },
    { label: 'Import', path: '/admin/import', icon: '⇧' },
    { label: 'Review Queue', path: '/admin/reviews', icon: '✓' },
    { label: 'Assets', path: '/admin/assets', icon: '◈' },
    { label: 'Student Quiz', path: '/student/practice', icon: '▶' },
    { label: 'Math Tables', path: '/learn/tables', icon: '×' },
    { label: 'Word World', path: '/learn/words', icon: 'W' },
    { label: 'Parent Portal', path: '/parent/dashboard', icon: 'P' },
    { label: 'Teacher Portal', path: '/teacher/dashboard', icon: 'T' },
    { label: 'Users', path: '/admin/users', icon: 'U' },
    { label: 'Settings', path: '/admin/settings', icon: '⚙' },
  ],
  content_admin: [
    { label: 'Dashboard', path: '/admin/dashboard', icon: '⌂' },
    { label: 'Question Bank', path: '/admin/questions', icon: 'Q' },
    { label: 'Import', path: '/admin/import', icon: '⇧' },
    { label: 'Review Queue', path: '/admin/reviews', icon: '✓' },
    { label: 'Assets', path: '/admin/assets', icon: '◈' },
  ],
  reviewer: [
    { label: 'Dashboard', path: '/reviewer/dashboard', icon: '⌂' },
    { label: 'Review Queue', path: '/reviewer/queue', icon: '✓' },
  ],
  teacher: [
    { label: 'Dashboard', path: '/teacher/dashboard', icon: '⌂' },
    { label: 'Classes', path: '/teacher/classes', icon: 'C' },
    { label: 'Assignments', path: '/teacher/assignments', icon: 'A' },
    { label: 'Reports', path: '/teacher/reports', icon: 'R' },
    { label: 'Math Tables', path: '/learn/tables', icon: '×' },
    { label: 'Word World', path: '/learn/words', icon: 'W' },
  ],
  parent: [
    { label: 'Dashboard', path: '/parent/dashboard', icon: '⌂' },
    { label: 'Children', path: '/parent/children', icon: 'C' },
    { label: 'Practice', path: '/parent/practice', icon: 'P' },
    { label: 'Reports', path: '/parent/reports', icon: 'R' },
    { label: 'Math Tables', path: '/learn/tables', icon: '×' },
    { label: 'Word World', path: '/learn/words', icon: 'W' },
  ],
  student: [
    { label: 'Home', path: '/student/dashboard', icon: '⌂' },
    { label: 'Assignments', path: '/student/assignments', icon: 'A' },
    { label: 'Practice', path: '/student/practice', icon: 'P' },
    { label: 'Progress', path: '/student/progress', icon: 'R' },
    { label: 'Math Tables', path: '/learn/tables', icon: '×' },
    { label: 'Word World', path: '/learn/words', icon: 'W' },
  ],
};
